// extracted by mini-css-extract-plugin
export default {"pais":"TablaTorneoSedes_pais__RgdYj"};